import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import MiniDrawer from '../components/navigation/DrawerMenu'
import ErrorBoundary from '../components/ErrorBoundary'
export default function Home() {
    return (
        <React.Fragment>
            <ErrorBoundary>
            <CssBaseline />
            <MiniDrawer title={" - Home"}>
            <Container maxWidth="sm">
                <Typography component="div" style={{ height: '100vh' }} >Home</Typography>
            </Container>
            </MiniDrawer>
            </ErrorBoundary>
        </React.Fragment>
    );
}